import BaseService from "./BaseService";

class UploadService {
  static async upload(file, type, onPogress) {
    let url = "/upload/scorm";
    if (type === 2) {
      url = "/upload/video";
    } else if (type === 3) {
      url = "/upload/pdf";
    } else if (type === "logo") {
      url = "/upload/logo";
    } else if (type === "image") {
      url = "/upload/image";
    } else if (type === "banner") {
      url = "/upload/banner";
    }
    const formData = new FormData();
    formData.append("File", file);
    return BaseService.uploadFile(url, formData, onPogress);
  }
}

export default UploadService;
